var React = require('react');

function SlideRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"a","d":"M268,273l9.862,9.862L278,283l-.139.138L268,293","transform":"translate(-267.293 -272.293)"}));
}

SlideRightInline.defaultProps = {"width":"12.123","height":"21.414","viewBox":"0 0 12.123 21.414"};

module.exports = SlideRightInline;

SlideRightInline.default = SlideRightInline;
